import WeightedList from 'js-weighted-list';
import { filter, find, flatten, flattenDepth, get, head, map, pullAt, set, some, sortBy } from 'lodash';

const shuffleItems = (parents, definitions, childId) => {
    return map(parents, parent => {
        const definition = find(definitions, { name: parent });
        const children = get(definition, childId, []);

        const do_shuffle = some(children, 'shuffleWeight');

        if (do_shuffle) {
            const items = map(children, (child, index) => ({ key: String(index), weight: 1.0, ...child }));
            // console.log(items);

            const weightedList = new WeightedList(items);
            const shuffledList = weightedList.shuffle();

            const reorderedList = filter(shuffledList, key => get(find(items, { key }), 'fixed', false) === false);
            // console.log(reorderedList);

            const values = map(items, item => {
                if (get(item, 'fixed', false)) return { ...item, key: Number(item.key) };
                else { const key = head(pullAt(reorderedList, [0])); set(item, 'key', Number(key)); return item; }
            });
            // console.log(values);

            const sortedList = sortBy(values, 'key');

            return { name: parent, values: flatten(map(sortedList, item => get(item, 'names', []))) };
        } else {
            return { name: parent, values: flatten(map(children, block => get(block, 'names', []))) };
        }
    });
};

/*
 * Create a graph from a specific version. A version contains a list of collections, each collection a list of blocks and each block a list of questions.
 * The blocks and questions may potentially be shuffled. For this reason the graph must contain not only the block list but also the order of the questions within each block
 */
const generateGraph = (survey, version) => {
    const definitions = get(survey, 'collections', []);

    const collections = get(version, 'collections', []);
    // console.log(collections);

    const shuffledBlocks = shuffleItems(collections, definitions, 'blocks');
    // console.log(shuffledBlocks);

    const justBlocks = flattenDepth(map(shuffledBlocks, item => get(item, 'values', [])), 2);
    // console.log(justBlocks);

    const definitions_ = get(survey, 'blocks', []);
    const graph = shuffleItems(justBlocks, definitions_, 'questions');
    // console.log(graph);

    return graph;
}

export default generateGraph;
